import { QueryResult, QueryConfig, QueryResponse, BaseQuery } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Departamento } from "@/shared/types/departamentos";

export interface DepartamentoQuery extends BaseQuery {
    nombre?: string,
    codigo?: string,
    ciudadId?: string,
    departamentoId?: string
}

export async function getAllDepartamentos(query?: DepartamentoQuery): Promise<QueryResponse<Departamento>> {
    await sleep(1000);
    const response = await api.get("departamento", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllDepartamentosQuery(query: DepartamentoQuery = {}, queryConfig: QueryConfig<QueryResponse<Departamento>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllDepartamentos(query),
        queryKey: ["departamentos", query],
    })
}

export interface GetAllDepartamentosQueryProps {
    query: DepartamentoQuery,
    queryConfig?: QueryConfig<QueryResponse<Departamento>>,
    children: (queryResult: QueryResult<QueryResponse<Departamento>>) => ReactNode
}

export function GetAllDepartamentosQuery({
    query,
    queryConfig,
    children
}: GetAllDepartamentosQueryProps) {
    const queryResult = useGetAllDepartamentosQuery(query, queryConfig);
    return children && children(queryResult);
} 